// extracted by mini-css-extract-plugin
export var sliderRange = "_no-2";
export var sliderRoot = "_no-0";
export var sliderThumb = "_no-3";
export var sliderTrack = "_no-1";